import { useEffect, useState } from 'react';
import { fullDateTime, messageTime, relative } from '@/lib/format';

// One shared ticker so every "x mins ago" on screen refreshes together (every 30 seconds).
const listeners = new Set<() => void>();
let timer: ReturnType<typeof setInterval> | null = null;
function subscribe(fn: () => void) {
  listeners.add(fn);
  if (!timer) timer = setInterval(() => listeners.forEach(l => l()), 30_000);
  return () => { listeners.delete(fn); if (!listeners.size && timer) { clearInterval(timer); timer = null; } };
}

/** Re-render with the shared 30-second ticker, for other relative wording (e.g. "Last active 5m ago"). */
export function useRelativeTick() {
  const [, tick] = useState(0);
  useEffect(() => subscribe(() => tick(n => n + 1)), []);
}

/** "just now" / "5 mins ago" / "yesterday" / "14 Oct", kept fresh, with the full date and time on hover. */
export function RelativeTime({ iso, className }: { iso: string; className?: string }) {
  const [, tick] = useState(0);
  useEffect(() => subscribe(() => tick(n => n + 1)), []);
  return <time dateTime={iso} title={fullDateTime(iso)} className={className} data-testid="relative-time">{relative(iso)}</time>;
}

/**
 * t267u: a chat message or thread time ("Just now", "5 min ago", "14:05", "Yesterday 14:05", "18 Oct, 06:05") on the same
 * shared ticker, with the full date and time on hover. `inline` for mid-sentence use ("Last reply just now").
 */
export function MessageTime({ iso, inline, className, testId = 'message-time' }: { iso: string; inline?: boolean; className?: string; testId?: string }) {
  useRelativeTick();
  return <time dateTime={iso} title={fullDateTime(iso)} className={className} data-testid={testId}>{messageTime(iso, { inline })}</time>;
}
